<template>
	<section class="member-passengers">
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<span>常旅客与联系人</span>
				<div>
					<el-input
						v-model="keyword"
						size="mini"
						placeholder="搜索姓名/证件"
						style="width: 220px; margin-right: 12px"
						clearable
					>
						<i slot="prefix" class="el-input__icon el-icon-search" />
					</el-input>
					<el-button type="primary" size="mini" @click="handleAdd">
						<i class="el-icon-plus"></i> 新增旅客
					</el-button>
				</div>
			</div>
			<el-table :data="filteredPassengers" size="small" v-loading="loading">
				<el-table-column prop="name" label="姓名" width="120" />
				<el-table-column prop="type" label="旅客类型" width="120" />
				<el-table-column prop="credential" label="证件号" min-width="200" />
				<el-table-column prop="mobile" label="手机号" width="150" />
				<el-table-column label="常用标签" min-width="180">
					<template slot-scope="{ row }">
						<el-tag
							v-for="tag in row.tags"
							:key="tag"
							size="mini"
							type="info"
							style="margin-right: 6px"
						>
							{{ tag }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="160">
					<template slot-scope="{ row }">
						<el-button type="text" size="mini" @click="handleEdit(row)">
							<i class="el-icon-edit"></i> 编辑
						</el-button>
						<!-- <el-button type="text" size="mini" style="color: #f56c6c" @click="handleDelete(row)">
							<i class="el-icon-delete"></i> 删除
						</el-button> -->
					</template>
				</el-table-column>
			</el-table>
		</el-card>

		<!-- 编辑/新增对话框 -->
		<el-dialog
			:title="dialogTitle"
			:visible.sync="dialogVisible"
			width="600px"
			:close-on-click-modal="false"
		>
			<el-form
				ref="passengerForm"
				:model="passengerForm"
				:rules="formRules"
				label-width="100px"
				size="small"
			>
				<el-form-item label="姓名" prop="fullName">
					<el-input v-model="passengerForm.fullName" placeholder="请输入姓名" />
				</el-form-item>

				<el-form-item label="英文姓" prop="lastNameEn">
					<el-input v-model="passengerForm.lastNameEn" placeholder="请输入英文姓" />
				</el-form-item>

				<el-form-item label="英文名" prop="firstNameEn">
					<el-input v-model="passengerForm.firstNameEn" placeholder="请输入英文名" />
				</el-form-item>

				<el-form-item label="性别" prop="sex">
					<el-radio-group v-model="passengerForm.sex">
						<el-radio label="1">男</el-radio>
						<el-radio label="0">女</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="出生日期" prop="birthday">
					<el-date-picker
						v-model="passengerForm.birthday"
						type="date"
						placeholder="选择日期"
						value-format="yyyy-MM-dd"
						style="width: 100%"
					/>
				</el-form-item>

				<el-form-item label="国籍" prop="nationality">
					<el-input v-model="passengerForm.nationality" placeholder="请输入国籍，如：CN" />
				</el-form-item>

				<el-form-item label="证件类型" prop="certificateType">
					<el-select
						v-model="passengerForm.certificateType"
						placeholder="请选择证件类型"
						style="width: 100%"
						@change="handleCertificateTypeChange"
					>
						<el-option
							v-for="item in certificateTypeList"
							:key="item.value"
							:label="item.name"
							:value="item"
						/>
					</el-select>
				</el-form-item>

				<el-form-item label="证件号" prop="certificateNumber">
					<el-input
						v-model="passengerForm.certificateNumber"
						placeholder="请输入证件号"
						@blur="handleCertificateNumberBlur"
					/>
				</el-form-item>

				<el-form-item label="证件有效期" prop="certificateEndDate">
					<el-date-picker
						v-model="passengerForm.certificateEndDate"
						type="date"
						placeholder="选择日期"
						value-format="yyyy-MM-dd"
						style="width: 100%"
					/>
				</el-form-item>

				<el-form-item label="手机号" prop="mobile">
					<el-input v-model="passengerForm.mobile" placeholder="请输入手机号" />
				</el-form-item>

				<el-form-item label="邮箱" prop="email">
					<el-input v-model="passengerForm.email" placeholder="请输入邮箱" />
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="handleSubmit" :loading="submitLoading">
					保 存
				</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
import { GetOftenPassengerList, SaveBookPassenger, GetMPassengerInfo } from '@/api/memberApi'
import { getUserAccount } from '@/utils/util'
import { getAccountInfo } from '@/utils/localdatas'

export default {
	name: 'MemberPassengers',
	props: {
		passengers: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			keyword: '',
			loading: false,
			dialogVisible: false,
			dialogTitle: '新增旅客',
			submitLoading: false,
			isEdit: false,
			currentPersonCode: '',
			passengerForm: {
				fullName: '',
				lastNameEn: '',
				firstNameEn: '',
				sex: '1',
				birthday: '',
				nationality: 'CN',
				certificateType: null,
				certificateNumber: '',
				certificateEndDate: '',
				mobile: '',
				email: ''
			},
			formRules: {
				fullName: [
					{ required: true, message: '请输入姓名', trigger: 'blur' }
				],
				certificateNumber: [
					{ required: true, message: '请输入证件号', trigger: 'blur' }
				]
			},
			certificateTypeList: [
				{ index: 0, value: 'ID', name: '身份证' },
				{ index: 1, value: 'PP', name: '护照' },
				{ index: 2, value: '10', name: '军人证' },
				{ index: 3, value: '11', name: '回乡证' },
				{ index: 4, value: '12', name: '台胞证' },
				{ index: 5, value: '13', name: '港澳通行证' },
				{ index: 6, value: 'NI', name: '其他' }
			]
		}
	},
	computed: {
		filteredPassengers() {
			if (!this.keyword) {
				return this.passengers
			}
			const kw = this.keyword.toLowerCase()
			return this.passengers.filter(
				item =>
					item.name.toLowerCase().includes(kw) ||
					(item.credential && item.credential.toLowerCase().includes(kw))
			)
		}
	},
	methods: {
		// 新增旅客
		handleAdd() {
			this.isEdit = false
			this.dialogTitle = '新增旅客'
			this.currentPersonCode = ''
			this.resetForm()
			this.dialogVisible = true
		},

		// 编辑旅客
		handleEdit(row) {
			this.isEdit = true
			this.dialogTitle = '编辑旅客'
			this.currentPersonCode = row.personCode || ''
			
			// 如果有原始数据，直接使用
			if (row.raw) {
				this.loadFormFromData(row.raw)
			} else {
				// 否则调用API获取详细信息
				this.loadPassengerInfo(row.personCode)
			}
			
			this.dialogVisible = true
		},

		// 从数据加载表单
		loadFormFromData(data) {
			this.passengerForm = {
				fullName: data.FullName || '',
				lastNameEn: data.LastNameEn || '',
				firstNameEn: data.FirstNameEn || '',
				sex: data.Sex || '1',
				birthday: data.BirthDay || '',
				nationality: data.Nationality || 'CN',
				certificateType: null,
				certificateNumber: '',
				certificateEndDate: '',
				mobile: data.Phone || '',
				email: data.Email || ''
			}

			// 处理证件信息
			if (Array.isArray(data.WXCredentials) && data.WXCredentials.length > 0) {
				const credential = data.WXCredentials[0]
				this.passengerForm.certificateNumber = credential.Number || ''
				this.passengerForm.certificateEndDate = credential.EndDate || ''
				
				// 查找对应的证件类型
				const certType = this.certificateTypeList.find(
					item => item.value === credential.ProofType
				)
				if (certType) {
					this.passengerForm.certificateType = certType
				}
			}
		},

		// 加载旅客详细信息
		loadPassengerInfo(personCode) {
			if (!personCode) return

			this.loading = true
			const params = {
				PersonCode: personCode,
				Account: getUserAccount()
			}

			GetMPassengerInfo(params, (result) => {
				this.loading = false
				if (result && result.code === 0 && result.data) {
					this.loadFormFromData(result.data)
				} else {
					this.$message.error('获取旅客信息失败：' + (result?.msg || '未知错误'))
				}
			})
		},

		// 证件类型改变
		handleCertificateTypeChange(value) {
			if (value && value.value === 'ID') {
				// 如果是身份证，可以自动识别性别和生日
				// 这里可以添加身份证识别逻辑
			}
		},

		// 证件号失焦（身份证自动识别）
		handleCertificateNumberBlur() {
			if (this.passengerForm.certificateType && 
			    this.passengerForm.certificateType.value === 'ID' && 
			    this.passengerForm.certificateNumber) {
				// 身份证号识别逻辑（需要引入相关工具函数）
				// 这里可以调用身份证识别函数自动填充性别和生日
			}
		},

		// 提交表单
		handleSubmit() {
			this.$refs.passengerForm.validate((valid) => {
				if (!valid) {
					return false
				}

				if (!this.passengerForm.certificateType) {
					this.$message.warning('请选择证件类型')
					return
				}

				this.submitLoading = true

				const accountInfo = getAccountInfo()
				const account = accountInfo?.Account || getUserAccount()

				// 构建证件类型对象
				const certificateTypeObj = {
					ID: this.passengerForm.certificateType.value === 'ID' ? this.passengerForm.certificateNumber : '',
					value: this.passengerForm.certificateType.value,
					name: this.passengerForm.certificateType.name,
					Number: this.passengerForm.certificateNumber,
					EndDate: this.passengerForm.certificateEndDate,
					CertificateTypeIndex: this.passengerForm.certificateType.index
				}

				const params = {
					Account: account,
					FullName: this.passengerForm.fullName,
					LastNameEn: this.passengerForm.lastNameEn,
					FirstNameEn: this.passengerForm.firstNameEn,
					Birthday: this.passengerForm.birthday,
					Nationality: this.passengerForm.nationality,
					Sex: this.passengerForm.sex,
					PersonCode: this.currentPersonCode, // 编辑时传入，新增时为空
					mobile: this.passengerForm.mobile,
					Email: this.passengerForm.email,
					CertificateType: JSON.stringify(certificateTypeObj)
				}

				SaveBookPassenger(params, (result) => {
					this.submitLoading = false
					if (result && result.code === 0) {
						this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
						this.dialogVisible = false
						// 触发父组件刷新数据
						this.$emit('refresh')
					} else {
						this.$message.error(result?.msg || '保存失败')
					}
				})
			})
		},

		// 删除旅客
		handleDelete(row) {
			this.$confirm('确定要删除该旅客吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// 这里可以调用删除API，暂时只提示
				this.$message.info('删除功能待实现')
				// TODO: 实现删除API调用
			}).catch(() => {})
		},

		// 重置表单
		resetForm() {
			this.passengerForm = {
				fullName: '',
				lastNameEn: '',
				firstNameEn: '',
				sex: '1',
				birthday: '',
				nationality: 'CN',
				certificateType: null,
				certificateNumber: '',
				certificateEndDate: '',
				mobile: '',
				email: ''
			}
			if (this.$refs.passengerForm) {
				this.$refs.passengerForm.clearValidate()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.member-passengers {
	.dialog-footer {
		text-align: right;
	}
}
</style>
